import React, { useState } from "react";
import { BrokenSavedView } from "common/utils/savedViews";
import { BANNER_TYPES } from "./__styles__/Banner";
import {
  BannerContent,
  SavedViewDetails,
  Toggle,
} from "./__styles__/BrokenSavedViews";
import Banner from "./Banner";
import { Body } from "./Typography";

const BrokenSavedViewsItem = ({
  savedView,
}: {
  savedView: BrokenSavedView;
}) => {
  return (
    <div>
      <Body type="emphasis" size="default">
        {savedView.name}
      </Body>
      {savedView.brokenFields.length > 0 && (
        <Body type="regular" size="default">
          Impacted Fields:{" "}
          {savedView.brokenFields.map(field => field.name).join(", ")}
        </Body>
      )}
      {savedView.brokenFilters.length > 0 && (
        <Body type="regular" size="default">
          Impacted Filters:{" "}
          {savedView.brokenFilters.map(filter => filter.name).join(", ")}
        </Body>
      )}
    </div>
  );
};

const BrokenSavedViews = ({
  brokenSavedViews,
  breakingCustomMaps,
}: {
  brokenSavedViews: BrokenSavedView[];
  breakingCustomMaps: string[];
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  if (brokenSavedViews.length === 0) {
    return null;
  }

  return (
    <Banner type={BANNER_TYPES.ATTENTION}>
      <BannerContent>
        <Body type="regular" size="default">
          Removing {breakingCustomMaps.join(", ")} may cause{" "}
          {brokenSavedViews.length} saved view(s) to break on this table.{" "}
          {!expanded && (
            <Toggle onClick={() => setExpanded(true)}>See impact</Toggle>
          )}
        </Body>
        {expanded && (
          <SavedViewDetails>
            {brokenSavedViews.map(savedView => (
              <BrokenSavedViewsItem savedView={savedView} key={savedView.id} />
            ))}
            <Toggle onClick={() => setExpanded(false)}>Hide</Toggle>
          </SavedViewDetails>
        )}
      </BannerContent>
    </Banner>
  );
};

export default BrokenSavedViews;
